import lastimg from '../assets/images/09img.svg';
import cardMiniImg from '../assets/images/CardMiniImg.jpg';
import closeIcon from '../assets/images/closePopupIcon.svg';
import fridgeImg from '../assets/images/fridgeImg.svg';
import goodsSet1 from '../assets/images/goodsSet_1.svg';
import goodsSet2 from '../assets/images/goodsSet_2.svg';
import goodsSet3 from '../assets/images/goodsSet_3.svg';
import goodsSet4 from '../assets/images/goodsSet_4.svg';
import goodsSet5 from '../assets/images/goodsSet_5.svg';
import homeIcon from '../assets/images/homeIcon.svg';
import homeIconActive from '../assets/images/homeIconActive.svg';
import menuIcon from '../assets/images/menu.svg';
import menuAccountIcon from '../assets/images/menuAccountIcon.svg';
import menuAccountIconActive from '../assets/images/menuAccountIcon_active.svg';
import menuLogoutIcon from '../assets/images/menuLogoutIcon.svg';
import menuLogoutIconActive from '../assets/images/menuLogoutIcon_active.svg';
import ordersIcon from '../assets/images/ordersIcon.svg';
import ordersIconActive from '../assets/images/ordersIconActive.svg';
import priceIcon from '../assets/images/priceIcon.svg';
import priceIconActive from '../assets/images/priceIconActive.svg';
import tiresImg from '../assets/images/tiresImg.svg';
import walletIcon from '../assets/images/walletIcon.svg';
import walletIconActive from '../assets/images/walletIconActive.svg';
import wardrobeImg from '../assets/images/wardrobeImg.svg';
import chairImg from '../assets/images/winter.svg';

const menuItems = [
  { path: '/', label: 'Мой склад', src: homeIcon, activeSrc: homeIconActive },
  { path: '/orders', label: 'Мои заказы', src: ordersIcon, activeSrc: ordersIconActive },
  {
    path: '/balance',
    label: 'Баланс и оплата',
    src: walletIcon,
    activeSrc: walletIconActive,
  },
  { path: '/prices', label: 'Тарифы', src: priceIcon, activeSrc: priceIconActive },
  { path: '/menu', label: 'Меню', src: menuIcon, activeSrc: menuIcon },
  { path: '/login', label: 'Закрыть', src: closeIcon, activeSrc: closeIcon },
];

const deliveryTimeOptions = [
  { value: '09:00-13:00', label: '09:00-13:00' },
  { value: '13:00-20:00', label: '13:00-20:00' },
];

const deliverySelfTimeOptions = [
  { value: '09:00-13:00', label: '09:00-13:00' },
  { value: '13:00-17:00', label: '13:00-17:00' },
  { value: '17:00-20:00', label: '17:00-20:00' },
];

const deliveryOnStoreTimeOptions = [
  { value: '09:00-13:00', label: '09:00-13:00' },
  { value: '13:00-17:00', label: '13:00-17:00' },
  { value: '17:00-22:00', label: '17:00-22:00' },
];

const elevatorTypeOptions = [
  { value: 'Грузовой', label: 'Грузовой' },
  { value: 'Пассажирский', label: 'Пассажирский' },
  { value: 'Нет', label: 'Нет' },
  { value: 'Оба', label: 'Оба' },
];

const payPeriodOptions = [
  { value: 1, label: '1 месяц', price: 1960, discount: '0' },
  { value: 2, label: '2 месяца', price: 3920, discount: '0' },
  { value: 3, label: '3 месяца', price: 5880, discount: '0' },
  { value: 4, label: '4 месяца', price: 7840, discount: '0' },
  { value: 5, label: '5 месяцев', price: 9800, discount: '0' },
  { value: 7, label: '7 месяцев', price: 13720, discount: '0' },
  { value: 8, label: '8 месяцев', price: 15680, discount: '0' },
  { value: 9, label: '9 месяцев', price: 17640, discount: '0' },
  { value: 10, label: '10 месяцев', price: 19600, discount: '0' },
  { value: 11, label: '11 месяцев', price: 21560, discount: '0' },
];

const menuOptions = [
  {
    label: 'Мой аккаунт',
    value: 'account',
    icon: menuAccountIcon,
    activeIcon: menuAccountIconActive,
  },
  {
    label: 'Выйти',
    value: 'logout',
    icon: menuLogoutIcon,
    activeIcon: menuLogoutIconActive,
  },
];

const ordersMiniCards = [
  {
    grm: '384 349',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 348',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 347',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 346',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 345',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 344',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 343',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 342',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 341',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 340',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
  {
    grm: '384 339',
    weight: 12,
    volume: 1.5,
    qty: 4,
    image: cardMiniImg,
    comment: 'Старый фиолетовый мопед',
  },
];

const user = {
  name: 'Василий',
  surname: 'Петров',
  phone: '+7(999)8888877',
  email: 'usermail@email.com',
};

const dropdownOptions = [
  {
    id: 1,
    placeholderTitle: 'Забор груза',
    price: '750',
    date: '12.10.2024, 19:00',
    address: 'Москва, Первомайская 24, 12',
    comment: 'Подъем на 4-й этаж, грузовой лифт, детали услуги',
  },
  {
    id: 2,
    placeholderTitle: 'Забор груза',
    price: '750',
    date: '12.10.2024, 19:00',
    address: 'Москва, Первомайская 24, 12',
    comment: 'Подъем на 4-й этаж, грузовой лифт, детали услуги',
  },
];

const bankCards = [
  {
    id: '1',
    num_bankCard: '4439781255076431',
    card_valPeriod: '',
    card_cvv: '',
    basic: true,
  },
  {
    id: '2',
    num_bankCard: '2204781255071234',
    card_valPeriod: '',
    card_cvv: '',
    basic: false,
  },
];

const cardsMenuOptions = [
  {
    label: 'Сделать основной',
    value: 'onBasic',
  },
  {
    label: 'Удалить карту',
    value: 'deleteCard',
  },
];

const tariffCards = [
  {
    id: '1',
    period: '3 месяц',
    price: '3 301',
    discount: '3',
    oldPrice: '3 403',
  },
  {
    id: '2',
    period: '6 месяцев',
    price: '19 398',
    discount: '5',
    oldPrice: '20 418',
  },
  {
    id: '3',
    period: '12 месяцев',
    price: '36 752',
    discount: '10',
    oldPrice: '40 836',
  },
];

const walletItems = [
  {
    id: '1',
    title: 'Ошибка оплаты',
    date: '12.10.2024',
    timeMin: '',
    timeMax: '19:00',
    balance: '-960',
  },
  {
    id: '2',
    title: 'Забор груза',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '-1500',
  },
  {
    id: '3',
    title: 'Забор груза',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '-960',
  },
  {
    id: '4',
    title: 'Хранение, 1 месяц',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '-1000',
  },
  {
    id: '5',
    title: 'Пополнение баланса',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '+3000',
  },
  {
    id: '6',
    title: 'Забор груза',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '-960',
  },
  {
    id: '7',
    title: 'Хранение, 1 месяц',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '-1000',
  },
  {
    id: '8',
    title: 'Забор груза',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '-960',
  },
  {
    id: '9',
    title: 'Хранение, 1 месяц',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '-1000',
  },
  {
    id: '10',
    title: 'Пополнение баланса',
    date: '12.10.2024',
    timeMax: '19:00',
    balance: '+3000',
  },
  {
    id: '11',
    title: 'Хранение, 1 месяц',
    date: '11.08.2024',
    timeMax: '20:00',
    balance: '-1900',
  },
  {
    id: '12',
    title: 'Забор груза',
    date: '11.10.2024',
    timeMax: '19:00',
    balance: '-2960',
  },
  {
    id: '13',
    title: 'Ошибка оплаты',
    date: '10.10.2024',
    timeMin: '',
    timeMax: '19:00',
    balance: '-2960',
  },
  {
    id: '14',
    title: 'Хранение, 1 месяц',
    date: '25.09.2024',
    timeMax: '18:00',
    balance: '-1000',
  },
  {
    id: '15',
    title: 'Забор груза',
    date: '09.09.2024',
    timeMax: '19:00',
    balance: '-960',
  },
  {
    id: '16',
    title: 'Ошибка оплаты',
    date: '09.09.2024',
    timeMin: '',
    timeMax: '19:00',
    balance: '-2960',
  },
  {
    id: '17',
    title: 'Ошибка оплаты',
    date: '09.09.2024',
    timeMin: '',
    timeMax: '19:00',
    balance: '-2960',
  },
  {
    id: '18',
    title: 'Хранение, 1 месяц',
    date: '11.08.2024',
    timeMax: '20:00',
    balance: '-1900',
  },
  {
    id: '19',
    title: 'Забор груза',
    date: '11.10.2024',
    timeMax: '19:00',
    balance: '-2960',
  },
  {
    id: '20',
    title: 'Ошибка оплаты',
    date: '10.10.2024',
    timeMin: '',
    timeMax: '19:00',
    balance: '-2960',
  },
  {
    id: '21',
    title: 'Хранение, 1 месяц',
    date: '25.09.2024',
    timeMax: '18:00',
    balance: '-1000',
  },
  {
    id: '22',
    title: 'Забор груза',
    date: '09.09.2024',
    timeMax: '19:00',
    balance: '-960',
  },
  {
    id: '23',
    title: 'Ошибка оплаты',
    date: '09.09.2024',
    timeMin: '',
    timeMax: '19:00',
    balance: '-2960',
  },
  {
    id: '24',
    title: 'Ошибка оплаты',
    date: '09.09.2024',
    timeMin: '',
    timeMax: '19:00',
    balance: '-2960',
  },
];

const priceItems = [
  {
    id: '1',
    tariffNumber: '01',
    title: 'Велосипеды и шины',
    volume: '0.5',
    sum: '1156',
    src: tiresImg,
  },
  {
    id: '2',
    tariffNumber: '02',
    title: 'Объём — 0,5 м³',
    volume: '1.5',
    sum: '1156',
    src: chairImg,
  },
  {
    id: '3',
    tariffNumber: '03',
    title: 'Объём — 1,5 м³',
    volume: '3',
    sum: '2215',
    src: fridgeImg,
  },
  {
    id: '4',
    tariffNumber: '04',
    title: 'Объём — 3 м³',
    volume: '6',
    sum: '3403',
    src: wardrobeImg,
  },
  {
    id: '5',
    tariffNumber: '05',
    title: 'Объём — 6 м³',
    volume: '9',
    sum: '6313',
    src: goodsSet1,
  },
  {
    id: '6',
    tariffNumber: '06',
    title: 'Объём — 9 м³',
    volume: '13',
    sum: '9523',
    src: goodsSet2,
  },
  {
    id: '7',
    tariffNumber: '07',
    title: 'Объём — 13 м³',
    volume: '18',
    sum: '12733',
    src: goodsSet3,
  },
  {
    id: '8',
    tariffNumber: '08',
    title: 'Объём — 18 м³',
    volume: '22',
    sum: '18083',
    src: goodsSet4,
  },
  {
    id: '9',
    tariffNumber: '09',
    title: 'Объём — 22 м³',
    volume: '22',
    sum: '21293',
    src: lastimg,
  },
  {
    id: '10',
    tariffNumber: 'Персональный тариф',
    title: 'Объём — любой',
    volume: '',
    sum: 'Индивидуально',
    src: goodsSet5,
  },
];

const priceItemsCompany = [
  {
    id: '1',
    tariffNumber: '01',
    volumeMin: '',
    volumeMax: '6,00 м³',
    titleTwo: '1 640',
  },
  {
    id: '2',
    tariffNumber: '02',
    volumeMin: '6,01 м³',
    volumeMax: '20,00 м³',
    titleTwo: '1 540',
  },
  {
    id: '3',
    tariffNumber: '03',
    volumeMin: '20,01 м³',
    volumeMax: '50,00 м³',
    titleTwo: '1 440',
  },
  {
    id: '4',
    tariffNumber: '04',
    volumeMin: '50,01 м³',
    volumeMax: '100,00 м³',
    titleTwo: '1 340',
  },
  {
    id: '5',
    tariffNumber: '05',
    volumeMin: '100,01 м³',
    volumeMax: '',
    titleTwo: '1 240',
  },
];

const faqDropdownOptions = [
  {
    id: 1,
    placeholderText: 'Сколько мне нужно места?',
    comment:
      'В Амбаре вы платите только за то место, которое занимаете. Мы поможем вам подобрать оптимальный тариф, исходя из объёма ваших вещей. Оставьте заявку на сайте или отправьте фото вещей на почту, чтобы получить точную оценку.',
  },
  {
    id: 2,
    placeholderText: 'Храните ли вы негабаритные вещи?',
    comment:
      'Да, мы храним вещи нестандартных габаритов, например, холодильник или диван. Вес 1-го грузового места не более 100 кг. Поэтому мы не перевозим пианино и любой антиквариат.',
  },
  {
    id: 3,
    placeholderText: 'Какие условия хранения на складе?',
    comment:
      'Вещи хранятся на отдельных паллетоместах на наших стеллажах. Склад сухой и тёплый. Мы обеспечиваем необходимый уровень влажности для безопасного хранения личных вещей.',
  },
  {
    id: 4,
    placeholderText: 'Что нельзя хранить?',
    comment:
      'На складе нельзя хранить горючие и взрывоопасные материалы, химию, опасные реагенты, пищевые продукты, растения и животных, антиквариат и всё, что запрещено законом РФ.',
  },
  {
    id: 5,
    placeholderText: 'Можно ли добавить вещи на хранение?',
    comment: 'Да, в любом количестве.',
  },
  {
    id: 6,
    placeholderText: 'Как происходит доставка?',
    comment:
      'Вы оформляете заявку на сайте — мы приезжаем по вашему адресу, аккуратно упаковываем вещи, загружаем в нашу грузовую машину и перевозим на склад. Вес 1-го грузового места не более 100 кг. Не перевозим пианино и антиквариат.',
  },
  {
    id: 7,
    placeholderText: 'Можно ли самостоятельно привезти вещи на склад?',
    comment:
      'Да, вы можете приехать на наш склад, расположенный по адресу: Москва, Троицк, ул. Промышленная 15. Мы примем вещи, упакуем и разместим на складе. В этом случае вы не платите за доставку.',
  },
  {
    id: 8,
    placeholderText: 'Сколько стоит доставка за МКАД?',
    comment:
      'Единая стоимость доставки вне зависимости от сложности и габаритов вещей по Москве — 2129 ₽ за 1 м³, за МКАД — 139 ₽ за 1 км, кроме ТиНАО, Подольск, Климовск.',
  },
  {
    id: 9,
    placeholderText: 'Как происходит обратная доставка?',
    comment:
      'Вы формируете заявку в личном кабинете — мы подтверждаем обратную доставку и удобное для вас время приёма вещей. Затем в течение 24 часов мы доставляем вам ваши вещи обратно.',
  },
  {
    id: 10,
    placeholderText: 'Как происходит оплата?',
    comment:
      'Оплата производится в личном кабинете клиента банковской картой или по выставленному заранее счёту после согласования условий хранения.',
  },
  {
    id: 11,
    placeholderText: 'Предоставляете ли вы упаковку?',
    comment:
      'Да, мы предоставляем упаковку для безопасной перевозки и хранения вещей на складе. Если вам нужна дополнительная упаковка, вы можете согласовать это в момент оформления заявки с оператором.',
  },
  {
    id: 12,
    placeholderText: 'Какие гарантии сохранности?',
    comment:
      'Склад оснащен системами безопасности, сигнализацией, системой пожаротушения. Въезд на территорию возможен только на основании предварительно заказанного пропуска. Вы получаете гарантию сохранности ваших вещей по договору.',
  },
];

const questionsOptions = [
  { value: 'order', label: 'Вопрос по заказу' },
  { value: 'prices', label: 'Услуги и цены' },
  { value: 'delivery', label: 'Забор и доставка' },
  { value: 'balance', label: 'Оплата и баланс' },
  { value: 'account', label: 'Настройка аккаунта' },
  { value: 'otherQuestions', label: 'Другое' },
];

export {
  bankCards,
  cardsMenuOptions,
  deliveryOnStoreTimeOptions,
  deliverySelfTimeOptions,
  deliveryTimeOptions,
  dropdownOptions,
  elevatorTypeOptions,
  faqDropdownOptions,
  menuItems,
  menuOptions,
  ordersMiniCards,
  payPeriodOptions,
  priceItems,
  priceItemsCompany,
  questionsOptions,
  tariffCards,
  user,
  walletItems,
};
